import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { installInstitutionFetch } from './institutionFetch';

// Add X-Institution-Id to every admin-backend fetch (must run before any request).
installInstitutionFetch();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
